import React from 'react'

export class Summary extends React.Component {
  render () {
    const { label, value, icon } = this.props

    return (
      <div
        className="shadow"
        style={{
          background: 'linear-gradient( 110deg, #69C0FF 3.66%, #5B79FB 90.94% )',
          color: 'white',
          padding: '0.75rem',
          borderRadius: '0.5rem',
          minWidth: '12rem',
          position: 'relative'
        }}
      >
        <div style={{ position: 'absolute', top: '0.5rem', right: '0.75rem', fontSize: '1.15rem' }}>{icon}</div>
        <div className="mb-2">
          <p className="m-0 text-white-50">{label}</p>
        </div>
        <p className="m-0 font-weight-bold"
           style={{ fontSize: '1.15rem' }}>{!(value === null || value === undefined) ? value : '-'}</p>
      </div>
    )
  }
}
